import { Sortable } from '@lib/util';
import { Router } from '@angular/router';
import { CustomRouter, IframeMessageTypeEnum, IframeService, View } from '@lib/core';

export interface IPurchaseRequisitionResult {
    id: string;
    statusId: number;
}

export interface IPurchaseRequisitionRfqResult extends IPurchaseRequisitionResult {
    rfqNumber: string;
    creationDate: string;
}

export interface IPurchaseRequisitionOrderResult extends IPurchaseRequisitionResult {
    orderDate: string;
    customerOrderNumber?: string;
}

export class PurchaseRequisitionRfqResult implements IPurchaseRequisitionResultDocument, Sortable {
    public static fromDto(dto: IPurchaseRequisitionRfqResult): PurchaseRequisitionRfqResult {
        return new PurchaseRequisitionRfqResult(dto.id, dto.creationDate, dto.rfqNumber, dto.statusId);
    }

    get navigatable(): boolean {
        return IframeService.inIframe();
    }

    constructor(
        private readonly _id: string,
        private readonly _creationDate: string,
        private readonly _rfqNumber: string,
        public readonly statusId: number
    ) {}

    get displayValue(): string {
        return this._rfqNumber;
    }

    navigate(): void {
        if (IframeService.inIframe()) {
            IframeService.sendMessage(IframeMessageTypeEnum.NAVIGATE_TO_RFQ, this._id);
        }
    }

    sortBy(): string {
        return this._creationDate;
    }
}

export class PurchaseRequisitionOrderResult implements IPurchaseRequisitionResultDocument, Sortable {
    public static fromDto(dto: IPurchaseRequisitionOrderResult): PurchaseRequisitionOrderResult {
        return new PurchaseRequisitionOrderResult(dto.id, dto.orderDate, dto.statusId, dto.customerOrderNumber);
    }

    readonly navigatable = true;

    constructor(
        private readonly _id: string,
        private readonly _orderDate: string,
        public readonly statusId: number,
        private readonly _customerOrderNumber?: string,
    ) {}

    get displayValue(): string {
        return this._customerOrderNumber || this._id;
    }

    navigate(router: Router | CustomRouter): void {
        if (IframeService.inIframe()) {
            IframeService.sendMessage(IframeMessageTypeEnum.NAVIGATE_TO_ORDER, this._id);
        } else {
            router.navigate([View.CLIENT, 'order', this._id, 'detail']);
        }
    }

    sortBy(): string {
        return this._orderDate;
    }
}

export interface IPurchaseRequisitionResultDocument {
    displayValue: string;
    statusId: number;
    navigatable: boolean;
    navigate(router: Router | CustomRouter): void;
}
